import { useMutation } from "react-query";
import { CreateCheckInAttendanceLog } from "services/workSchedule";

export default function useCreateCheckInAttendanceLog() {
  return useMutation(
    (data:any) => CreateCheckInAttendanceLog(data),
  );
}